import { render, staticRenderFns } from "./AnchorLinkModal.vue?vue&type=template&id=c0f633fe&scoped=true"
import script from "./AnchorLinkModal.vue?vue&type=script&lang=js"
export * from "./AnchorLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f633fe",
  null
  
)

export default component.exports